export default __webpack_public_path__ + "static/media/Helm of the Ascension.647ea96e.jpg";